import Axios, { AxiosRequestConfig } from "axios";

const baseURL: string = process.env.REACT_APP_API_BASE_URL || "localhost";
const instance = Axios.create({
  baseURL,
  timeout: 50000
} as AxiosRequestConfig);

export default instance;
